<template>
  <div class="w-100 no-gap">
    <CCarousel :key="carouselKey" class="ccarousel" arrows indicators animate>
      <CCarouselItem
          v-for="(slide, index) in slides"
          :key="slide._id"
          :captionHeader="slide.slide_header"
          :captionText="slide.slide_label"
      >
        <template #default>
          <div class="slide-wrapper">
            <img :src="slide.slide_img" :key="slide.slide_img" alt="Slide Image" class="carousel-item-img" />
            <div class="slide-overlay"></div> <!-- ✅ overlay -->
            <div class="carousel-caption">
              <h3>{{ slide.slide_header }}</h3>
              <p>{{ slide.slide_label }}</p>
              <div>
                <a :href="slide.link" class="custom-btn" target="_blank">Click &raquo;</a>
              </div>
              <button class="btn btn-sm btn-warning edit-btn" @click="startEdit(index)">Edit</button>
            </div>
          </div>
        </template>
      </CCarouselItem>
    </CCarousel>

    <!-- Modal -->
    <div v-if="modalVisible" class="modal-overlay" @click.self="cancelEdit">
      <div class="modal-content">
        <h4>Edit Slide</h4>

        <form @submit.prevent="saveEdit">
          <div class="form-group mb-2">
            <label class="form-label fw-bold">Upload Image:</label>
            <div class="mb-1">
              <input
                  type="file"
                  accept="image/*"
                  @change="onFileChange"
                  class="custom-file-upload"
              />
            </div>
            <small style="color: #d33; font-weight: 500;">Recommended image height: 400px</small>

            <div v-if="editSlide && editSlide.slide_img" class="mt-3">
              <img :src="editSlide.slide_img" alt="Preview" class="preview-image" />
            </div>
          </div>

          <div class="form-group mb-2">
            <label>Header:</label>
            <input type="text" class="form-control" v-model="editSlide.slide_header" required />
          </div>
          <div class="form-group mb-2">
            <label>Label:</label>
            <textarea class="form-control" v-model="editSlide.slide_label" required></textarea>
          </div>
          <div class="form-group mb-2">
            <label>Link URL:</label>
            <input type="url" class="form-control" v-model="editSlide.link" />
          </div>

          <div class="modal-buttons">
            <button type="submit" class="btn btn-sm btn-success mr-2">Save</button>
            <button type="button" class="btn btn-sm btn-secondary" @click="cancelEdit">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/service/api'
import '@/assets/css/slide.css'

export default {
  name: 'EditSlide',
  data() {
    return {
      slides: [],
      editIndex: null,
      editSlide: null,
      modalVisible: false,
      carouselKey: Date.now(), // 👈 เพิ่ม key
      allowedIds: [
        '687f2e24420b887eea1f2f22', // Slide 1
        '687f2e4d420b887eea1f2f25', // Slide 2
        '687f2e71420b887eea1f2f28',
      ],
    }
  },
  mounted() {
    this.fetchSlides()
  },
  methods: {
    async fetchSlides() {
      try {
        const res = await api.slide('get')
        this.slides = (res.data.data || [])
            .filter(slide => this.allowedIds.includes(slide._id))
            .map(slide => ({
              ...slide,
              slide_img: this.getFullImagePath(slide.slide_img),
            }))
        // 👇 force render ใหม่
        this.carouselKey = Date.now()
      } catch (err) {
        console.error(err)
      }
    },
    getFullImagePath(path) {
      return path ? `https://election-su.mfu.ac.th${path}` : ''
    },
    startEdit(index) {
      this.editIndex = index
      this.editSlide = { ...this.slides[index] }
      this.modalVisible = true
    },
    async saveEdit() {
      const slide = this.editSlide
      try {
        await api.slide('put', {
          _id: slide._id,
          slide_header: slide.slide_header,
          slide_label: slide.slide_label,
          link: slide.link,
        })

        if (slide.newImageFile) {
          await api.slide('putslidePicture', {
            id: slide._id,
            image: slide.newImageFile,
          })
        }

        this.fetchSlides()
        this.cancelEdit()
      } catch (err) {
        console.error(err)
      }
    },
    cancelEdit() {
      this.editIndex = null
      this.editSlide = null
      this.modalVisible = false
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

      if (!validImageTypes.includes(file.type)) {
        this.$swal.fire({
          icon: 'error',
          title: 'Invalid File Type',
          text: 'Please select an image file only (jpg, png, gif, webp)',
          confirmButtonText: 'OK'
        });
        event.target.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = e => {
        this.editSlide.slide_img = e.target.result;
        this.editSlide.newImageFile = file;
      };
      reader.readAsDataURL(file);
    }
  },
}
</script>
